module.exports = __webpack_public_path__ + "img/refresh.251d8ce1.svg";